import { createAction } from "redux-starter-kit";
import { CLOSE_CREATE_DEBTOR } from "../../types";

export default () => createAction(CLOSE_CREATE_DEBTOR)();
